import React, {useEffect} from 'react'

import styled from 'styled-components'
import {useEffectOnce} from 'react-use'

import {usePago} from '../PagoContext'
import {CircularLoader} from './StatusComponents'

const Root = styled.div`
  iframe {
    height: 100%;
    min-height: 70dvh;
  }

  @media (max-height: 800px) {
    iframe {
      min-height: 55dvh;
    }
  }
`
interface PagoIframeTermsProps {
  onSigningComplete: () => void
}

// TODO: Hvernig höndlar framendinn það þegar notandi hættir við eða failar á undirritun skilmála?
export default function PagoIframeTerms({
  onSigningComplete,
}: PagoIframeTermsProps) {
  const {termsUrl, handleRegistrationUrl} = usePago()

  const [loading, setLoading] = React.useState<boolean>(false)

  useEffect(() => {
    const handler = (
      ev: MessageEvent<{type: string; message: string}>,
    ): void => {
      if (typeof ev.data !== 'object') return

      if (!ev.data.type) return

      if (ev.data.type === 'signing_completed') {
        onSigningComplete()
        setLoading(true)
      }
    }

    window.addEventListener('message', handler)

    return (): void => window.removeEventListener('message', handler)
  }, [onSigningComplete])

  useEffectOnce(() => {
    handleRegistrationUrl('POST', undefined, 'type=terms')
    setLoading(false)
  })

  if (loading || !termsUrl) {
    return <CircularLoader text="Augnablik ..." />
  }

  return (
    <Root>
      <iframe src={termsUrl} width="100%" title="Snjallgreiðslur skilmálar" />
    </Root>
  )
}
